export default function Container({ children, padding, style }) {
    if (isNaN(padding)) padding = 0;
    return (<div 
        className="yona-conatiner" 
        style={{ 
            verticalAlign: "top", 
            display: "inline-block",
            ...style, 
            padding: padding * 8
        }}>{children}</div>);
}